import { createBrowserRouter } from 'react-router-dom';

import routesWithViews from './routesWithViews';

const router = createBrowserRouter(routesWithViews);

export default router;
